import angular from 'angular';
import productSearchModule from './directives/productSearchModule.js';
import 'angular-sanitize';
import 'angular-resource';
import 'angular-touch';
import 'angular-route';

const cartModule = angular.module('cart', [
    'nsShop',
    'nsUtil',
    productSearchModule.name,
    'ngSanitize',
    'ngResource',
    'ngTouch',
    'ngRoute'
]);

export default cartModule;
